import P5 from "p5";
import { Bird } from "./bird";
import { Wall } from "./wall";

// Creating the sketch itself
const sketch = (p5: P5) => {
	var bird: Bird | undefined;
	var wall: Wall | undefined;
	var wall2: Wall | undefined;
	var canvasHeight = 600;
	var canvasWidth = 800;
	var score = 0;
	var highScore = 0;

	// The sketch setup method 
	p5.setup = () => {
		let canvas = p5.createCanvas(canvasWidth, canvasHeight);
		canvas.parent('canvas');
		bird = new Bird(p5);
		wall = new Wall(p5, canvasWidth, canvasHeight);
		wall2 = new Wall(p5, canvasWidth, canvasHeight);
		wall2.x = canvasWidth/2;
	};

	// The sketch draw method
	p5.draw = () => {
		p5.background(100,100,200);
		if (bird && wall && wall2) {
			bird.show();
			wall.show();
			wall2.show();
			bird.update();
			wall.update();
			wall2.update();
			if (collide(bird, wall) || collide(bird, wall2)){
				if (score > highScore){
					highScore = score;
				}
				score = 0;
				wall.x = canvasWidth;
				wall2.x = canvasWidth/2;
				bird.y = canvasHeight/2;
				bird.speedy = 0;
			}
			score = score + 1;
			p5.fill(255);
			p5.text("Score: " + score.toFixed(0), 10, 20);
			p5.text("HighScore: " + highScore.toFixed(0), 10,35);
		}
	};

	p5.keyPressed = (event: Object | undefined) => {
		if (!event) return;
		if (event['keyCode'] === 32) {
			bird?.flap();
		}
	}

	function collide(b: Bird, w: Wall){
		if ((b.x + b.width >= w.x && b.x + b.width <= w.x + w.width) || (b.x >= w.x && b.x <= w.x + w.width)){
			if (b.y <= w.gapHeight || b.y+b.height >= w.gapHeight+w.gapSize){
				return 1;
			}
		}
		if (b.y > canvasHeight || b.y < 0){
			return 1;
		}
		return 0;
	}
};

new P5(sketch);

